import { RetryPromiseBase } from './RetryPromiseBase';
import { logErrorExternally } from '@/functions/logErrorExternally';
import { HttpStatus } from '@/constants';

/**
 * Allows for running a promise and retrying failures with time between attempts that increases with
 * exponential backoff. Tries again quickly for the first few attempts, then waits longer and longer
 * between attempts. Has a fixed maximum number of attempts and a maximum amount of time to wait
 * between attempts.
 */
export class RetryPromiseWithBackoff extends RetryPromiseBase {
  constructor(httpCodesToFailImmediately = [HttpStatus.BAD_REQUEST]) {
    super(logErrorExternally, httpCodesToFailImmediately);
  }
}
